export const sliderInicial = [
  { acima_de: 5000, abaixo_de: -100 },
  { acima_de: 50, abaixo_de: -200 },
  { acima_de: 200, abaixo_de: -10 },
  { acima_de: "", abaixo_de: "" },
];
